import { useState } from "react";
import { Pagination } from "../../../ui/organisms/pagination";
import { ItemsPerPageValues } from "../../../ui/organisms/pagination/dto";
import { CopyTargetListToProjectModal } from "../copyToProjectModal";
import { FindAllTargetListsFilters, FindAllTargetListsResponse } from "../dto";
import { TargetListTable } from "./table";
import { UserDTO } from "../../users/dto";

interface Props {
  targetLists: FindAllTargetListsResponse
  teamLeaders: { user: UserDTO, avatar: string }[]
  commercials: { user: UserDTO, avatar: string }[]
  filters: FindAllTargetListsFilters
  setFilters: (filters: Partial<FindAllTargetListsFilters>) => void
  setItemsPerPage: (itemsPerPage: ItemsPerPageValues) => void
  setPage: (page: number) => void
  isFromProject?: boolean
}

export function TargetListsList({ targetLists, filters, setFilters, setItemsPerPage, setPage, teamLeaders, commercials, isFromProject }: Props) {
  const [targetListToCopy, setTargetListToCopy] = useState<string | undefined>(undefined);
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  return (
    <div className="w-[100%] rounded-b-xl shadow-sm bg-white flex flex-col" style={{ height: 'calc(100% - 64px)' }}>
      <TargetListTable
        isFromProject={isFromProject}
        teamLeaders={teamLeaders}
        commercialsList={commercials}
        targetLists={targetLists}
        filters={filters}
        setFilters={setFilters}
        setTargetListToCopy={setTargetListToCopy}
        setShowCopyModal={setIsCopyModalVisible}
      />
      <Pagination
        itemsPerPage={filters.itemsPerPage}
        setItemsPerPage={value => setItemsPerPage(value)}
        found={targetLists.total || 0}
        pages={targetLists.totalPage || 1}
        currentPage={filters.page}
        setPage={(page) => setPage(page)}
      />
      <CopyTargetListToProjectModal
        visible={isCopyModalVisible}
        onClose={() => setIsCopyModalVisible(false)}
        targetId={targetListToCopy}
      />
    </div>
  );
}
